var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"10","offset":"1"}},[(_vm.mode === 'imprint')?_c('Imprint'):_c('Privacy')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }